export default __webpack_public_path__ + "static/media/Mekor_Omoda_C9_Vehicle_Teaser_Banner.d3bf3e09.webp";